import * as types from "./types";
import _ from 'lodash';
export const defaultState = {
  requests: {},
  loading: false,
  errors: [],
  update_status: {}   //for individual loaders 
};

const member_requests = (state = defaultState, action) => {
  switch (action.type) {
     
    case types.FETCHED_MEMBER_REQUESTS:    
    case types.SEND_MEMBER_REQUEST:    
      let existent_requests = {...state.requests};       
      existent_requests[action.circleId] = action.requests;
      return {
        ...state,
        requests: existent_requests,
        loading: action.loading        
      }
    case types.SENDING_MEMBER_REQUEST:    
    case types.FETCHING_MEMBER_REQUESTS:       
      return {
        ...state,
        loading: action.loading
      }
    case types.UPDATING_MEMBER_REQUESTS_STATUS:       
      return {
        ...state,
        update_status: {...state.update_status, [action.requestId]:true}
      }
    case types.REMOVE_MEMBER_REQUEST:  
      let updates = {...state.update_status};
      delete updates[action.requestId];   
      existent_requests = {...state.requests};       
      _.remove(existent_requests[action.circleId], {guid: action.requestId});
      if(existent_requests[action.circleId].length===0){
        delete existent_requests[action.circleId];
      } 
      return {
        ...state,
        requests: existent_requests,
        update_status: updates
      }
    case types.ERROR_UPDATING_MEMBER_REQUEST:
      updates = {...state.update_status};
      delete updates[action.requestId];
      return {
        ...state,
        errors: [...state.errors, action.error],
        update_status: updates
      }
    case types.ERROR_FETCHING_MEMBER_REQUESTS:
    case types.ERROR_JOIN_REQUEST:
      return {
        ...state,
        errors: [...state.errors, action.error],
        loading: action.loading
      }
    default:
      return state;
  }
};
export default member_requests;
